$('document').ready(function () {
    // Helper functions (only once)
    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/';
    }

    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? match[2] : null;
    }

    /*** PAGE POPUP ***/
    var $pagePopup = $('.popup-wrap');
    if ($pagePopup.length) {
        var version = $pagePopup.data('popup-version') || 1;
        var cookieName = 'popup_page_seen_v' + version;

        if (!getCookie(cookieName)) {
            setTimeout(function () {
                $pagePopup.fadeIn();
            }, 2000);
        }

        function closePagePopup() {
            setCookie(cookieName, 'yes', 30);
            $pagePopup.fadeOut();
        }

        $pagePopup.find('.popup-close').on('click', function (e) {
            e.stopPropagation();
            closePagePopup();
        });

        $pagePopup.on('click', function () {
            closePagePopup();
        });

        $pagePopup.find('.popup-content').on('click', function (e) {
            e.stopPropagation();
        });
    }

    /*** GLOBAL POPUP ***/
    var $globalPopup = $('.popup-global');
    if ($globalPopup.length) {
        var version = $('body').data('global-popup-version') || 1;
        var cookieName = 'popup_global_seen_v' + version;

        if (!getCookie(cookieName)) {
            setTimeout(function () {
                $globalPopup.fadeIn();
            }, 2000);
        }

        function closeGlobalPopup() {
            setCookie(cookieName, 'yes', 30);
            $globalPopup.fadeOut();
        }

        $globalPopup.find('.popup-close').on('click', function (e) {
            e.stopPropagation();
            closeGlobalPopup();
        });

        $globalPopup.on('click', function () {
            closeGlobalPopup();
        });

        $globalPopup.find('.popup-global-content').on('click', function (e) {
            e.stopPropagation();
        });
    }

    // Page Loader
    $('.page-loader').fadeOut();

    $('.mobile-menu-button').click(function () {
        $('.mobile-menu').slideToggle();
        $(this).toggleClass('active');
        $('body').toggleClass('mobile-menu-active');
    });

    $('.search-container').click(function (event) {
        event.preventDefault();
        if ($('.search-container').hasClass('active')) {
            //$('.search-container').removeClass('active');
        } else {
            $('.search-container').addClass('active');
            $('.search-container #search').val('');
            setTimeout(function () {
                $('.search-container #search').focus();
            }, 400);
        }
    });

    $('.mobile-menu ul li.menu-item-has-children > a').click(function (event) {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
        } else {
            $(this).parent().addClass('active');
            event.preventDefault();
        }
    });

    $(document).mouseup(function (e) {
        var container = $('.search-container');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.removeClass('active');
        }
    });

    function initializeAccordion($scope) {
        // If $scope is not defined, default to the entire document
        $scope = $scope || $(document);

        // Initialize accordion within the scope
        $scope
            .find('.accordion__title')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                var $this = $(this);

                if (!$this.hasClass('accordion-active')) {
                    $scope.find('.accordion__content').slideUp(400);
                    $scope.find('.accordion__title').removeClass('accordion-active');
                }

                $this.toggleClass('accordion-active');
                $this.next().slideToggle();
            });
    }

    // Initialize accordion globally on page load
    $(document).ready(function () {
        initializeAccordion(); // Affects all accordions
    });

    // Reinitialize accordion specifically in the FacetWP template after AJAX load
    $(document).on('facetwp-loaded', function () {
        initializeAccordion($('.facetwp-template')); // Scoped to FacetWP pagination area
    });

    $('.flex-panel').each(function () {
        if ($(this).find('.list-wrap').length !== 0) {
            $(this).find('.row > div').removeClass('justify-content-center');
            $(this).find('.row > div').addClass('justify-content-start');
        }
    });

    $('.pop-up-link').click(function (event) {
        event.preventDefault();

        /*
		var name = $(this).data('name');
		var position = $(this).data('position');
		var bio = $(this).data('bio');
		$('.black_overlay').fadeIn();
		$('.white_content').fadeIn();
		$('.white_content').find('.member-name').html(name);
		$('.white_content').find('.member-position').html(position);
		$('.white_content').find('.member-bio').html(bio);
		*/
    });
    $('.close-popup').click(function (event) {
        event.preventDefault();
        $('.black_overlay').fadeOut();
        $('.white_content').fadeOut();
    });

    if ($(window).scrollTop() > 20) {
        $('.header').addClass('sticky');
    }

    // If vacancies
    if ($('body').hasClass('page-vacancies')) {
        if ($('#panel-1').length != 0) {
            if ($("p:contains('Vacancies')")) {
                $('.count-box').parent().addClass('hide');
                $('.count-box').appendTo($("p:contains('Vacancies')"));
            }
        }
    }

    // Initial check on page load
    loadTrustpilotWidget();

});

$(window).scroll(function () {
    let scroll = $(window).scrollTop();
    if (scroll > 20) {
        $('.header').addClass('sticky');
    } else {
        $('.header').removeClass('sticky');
    }
});

// Function to check if the screen size is at least 768px
function loadTrustpilotWidget() {
    //if (window.matchMedia("(min-width: 768px)").matches) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    document.head.appendChild(script);
    //}
}

// Listen for window resize events to handle dynamic changes
window.addEventListener('resize', function () {
    // Remove any existing Trustpilot widget script if the screen size becomes less than 768px
    if (!window.matchMedia('(min-width: 768px)').matches) {
        var existingScript = document.querySelector(
            'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]',
        );
        if (existingScript) {
            existingScript.parentNode.removeChild(existingScript);
        }
    } else {
        // Ensure the script is loaded if the screen size becomes at least 768px
        if (
            !document.querySelector(
                'script[src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"]',
            )
        ) {
            loadTrustpilotWidget();
        }
    }
});

// Census download
document.addEventListener(
    'wpcf7mailsent',
    function (event) {
        if (event.detail.contactFormId === 1573 || event.detail.contactFormId === 1567) {
            // Static URL of the PDF file to download
            var pdfUrl =
                'https://wearesapphire.co.uk/contracting/wp-content/uploads/sites/3/2024/09/Sapphire-Contracting-Census-2024.pdf';

            // Create a temporary link element
            var link = document.createElement('a');
            link.href = pdfUrl;
            link.download = ''; // Empty string triggers download
            link.target = '_blank'; // Open in a new tab

            // Append the link to the body
            document.body.appendChild(link);

            // Programmatically click the link to trigger the download
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        }
    },
    false,
);

// Thank you redirects
document.addEventListener(
    'wpcf7mailsent',
    function (event) {
        if (event.detail.contactFormId === 1897) {
            window.location.href = 'https://wearesapphire.co.uk/contracting/thank-you-umbrella/';
        }
        if (event.detail.contactFormId === 2018) {
            window.location.href = 'https://wearesapphire.co.uk/contracting/thank-you-hub-form/';
        }
    },
    false,
);
